<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<div class="section-title">
			<h1 class="active" v-bind="ADAattr('h1')">
				Select Tax Exemption
			</h1>
		</div>

		<v-form ref="tax_exempt_form" v-model="form_valid" lazy-validation v-if="!submitting">
			<v-container fluid pa-4>
				<v-layout wrap justify-space-between>

					<v-flex xs12>
						<v-layout wrap justify-space-between>
							<v-flex xs12>
								<v-card flat>
									<v-card-text class="pa-0" v-bind="ADAattr('focus')">
										Students ordering required materials, excluding rentals, are tax exempt
									</v-card-text>
								</v-card>
							</v-flex>

							<v-flex xs12 md7 py-0>
								<v-combobox
										:items="schools"
										v-model="school"
										label="Enter your School Name"
										:rules="rules.school"
										class="co-text-field"
										item-value="id"
										item-text="name"
										v-bind="ADAattr('list')"
								>
									<template v-slot:item="data">
										<div class="co-tax-exempt-combo-item">
											{{ data.item.name }}
										</div>
									</template>

								</v-combobox>
							</v-flex>
							<v-flex xs5 hidden-xs-only></v-flex>

							<v-flex xs12 md7 py-0>
								<v-text-field
										v-model="course_name"
										label="Course(s)"
										:rules="rules.course_name"
										class="co-text-field"
								></v-text-field>
							</v-flex>
							<v-flex xs5 hidden-xs-only></v-flex>

							<v-flex xs12 md7 py-0>
								<v-text-field
										v-model="student_id"
										label="Student ID"
										:rules="rules.student_id"
										class="co-text-field"
										v-bind="ADAattr('label', `Student ID. Do NOT enter your Social Security Number in this field,
										if your school uses Social Security Number as ID enter SS for Student ID`)"
								></v-text-field>
							</v-flex>
							<v-flex xs7 hidden-xs-only></v-flex>

							<v-flex xs12 pt-3>
								<v-card flat v-bind="ADAattr('hidden')">
									<v-card-text class="co-do-not-enter-ssn">
										<v-layout>
											<div>
												<v-icon color="#2170f2">error_outline</v-icon>
											</div>
											<div>
												<strong>Do NOT enter your Social Security Number in this field</strong> <br>
												<span>If your school uses Social Security Number as ID enter "SS" for Student ID</span>
											</div>
										</v-layout>
									</v-card-text>
								</v-card>
							</v-flex>

							<v-flex xs12>
								<v-checkbox
									v-model="accept" 
									label="I Certify that..."
									hide-details
									v-bind="ADAattr('label', `I Certify that I am full- or Part-Time student enrolled at a qualified institution of higher education
									and I am using this ${voucher_name} to purchase the eligible textbooks listed above
									that are required or recommended to use in a course at above institution of higher education.`)"
								></v-checkbox>

								<v-card flat v-bind="ADAattr('hidden')">
									<v-card-text class="co-i-certify">
										<ul>
											<li>
												I am full- or Part-Time student enrolled at a qualified institution of higher education.
											</li>
											<li>
												I am using this {{voucher_name}} to purchase the eligible textbooks listed
												above that are required or recommended to use in a course at above institution of higher education.
											</li>
										</ul>
									</v-card-text>
								</v-card>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-container>
		</v-form>

		<div class="co-submit-panel pt-3">
			<v-divider
					class="pb-2"
					v-if="!submitting"
					v-bind="ADAattr('hidden')"
			></v-divider>

			<v-btn
					id="btn-checkout-step-tax-exemption-submit"
					:dark="accept && !submitting"
					color="#2170f2"
					@click="submit"
					:loading="submitting"
					v-bind="ADAattr('button-readonly', !accept || submitting, 'Submit tax exemption',
					!accept ? 'Please check all fields before continue' : 'Please wait')"
			>
				Continue
			</v-btn>

			<v-btn
					id="btn-checkout-step-tax-exemption-skip"
					dark
					color="#2170f2"
					@click="skip"
					v-if="!submitting"
			>
				Skip Tax Exemption
			</v-btn>
		</div>
	</div>
</template>

<script>
	import Axios from 'axios';

	export default {
		name: "TaxExemptForm",

		props: {
			schools: {
				type: Array,
				default: [],
			},
			submitting: {
				type: Boolean,
				default: false,
			},
		},

		data() {
			return {
				form_valid: false,
				school: '',
				course_name: '',
				student_id: '',
				accept: false,

				rules: {
					school: [
						v => _.isObject(v) || !!(v && v.trim && v.trim()) || 'Please select or enter the school name',
					],
					course_name: [
						v => !!v.trim() || 'Course(s) field is required',
					],
					student_id: [
						v => !!v.trim() || 'Student ID is required',
					],
				},
			};
		},

		methods: {
			prefill() {
				this.school = _.find(this.schools, s => s.institute_id == this.$globs.institute_id) || '';
				this.course_name = this.$globs.prefill.tax_exempt_courses || '';
				this.student_id = this.$globs.prefill.tax_exempt_student_id || '';
			},

			submit() {
				const self = this;

				if (!self.$refs.tax_exempt_form.validate()) {
					return;
				}

				let data = _.isObject(self.school) ? self.school : {
					id: null,
					name: self.school,
				};

				self.$emit('submit', {
					success: true,
					data: {
						...data,
						course_name: self.course_name,
						student_id: self.student_id,
					},
				});
			},
			skip() {
				const self = this;

				self.$emit('skip');
			},
		},

		mounted() {
			this.prefill();
		},
		computed: {
			voucher_name() {
				return this.$globs['is_inst'] ? this.$globs['voucher_name'].toLocaleLowerCase() : 'certificate'
			}
		}
	};
</script>

<style scoped lang="less">
	@text_highlight_color: #2170f2;

	.co-do-not-enter-ssn {
		padding: 0;
		display: block;

		> div {
			line-height: 24px;
			vertical-align: middle;

			i {
				display: block;
				margin-right: 10px;
			}

			strong {
				color: @text_highlight_color;
			}
		}

		span {
			display: block;
		}
	}

	.co-i-certify {
		padding: 0;
		margin: 0;

		ul {
			padding: 0 0 0 46px;
			margin: 0;

			> li {
				margin: 0;
				padding: 0;
			}
		}
	}

	.co-tax-exempt-combo-item {
		width: 320px;
	}
</style>